import * as UI from "@iyk/ui"

import { ExclusiveContainer } from "./exclusive-container.tsx"
import { Sheet } from "./sheet.tsx"
import { useExclusiveSheet } from "./use-exclusive-sheet.ts"

export const ExclusiveSweepstakeCard = (props: ExclusiveSweepstakeCard.Props) => {
  const [open, setOpen] = useExclusiveSheet(props.id)

  return (
    <Sheet.Root open={open} onOpenChange={setOpen}>
      <Sheet.Trigger>
        <ExclusiveContainer>
          <div className="absolute inset-0 size-full">
            <img src={props.coverImage} alt={props.title} className="size-full object-cover" />
            <div className="absolute bottom-0 left-0 w-full h-1/4 bg-[linear-gradient(to_top,_black,_rgba(0,0,0,0))]" />
          </div>
          <div className="absolute left-2 top-2">
            <SweepstakeBadge isWinner={props.isWinner} />
          </div>
          <div className="absolute right-2 bottom-2">
            <span className={UI.classForButton({ kind: "solid", size: "sm" })}>
              <UI.Icon.Ticket />
            </span>
          </div>
          <div className="absolute left-2 bottom-2 text-xs text-start">
            <h3>{props.title}</h3>
            {props.subtitle && <p className="mt-0.5 text-gray-11">{props.subtitle}</p>}
          </div>
        </ExclusiveContainer>
      </Sheet.Trigger>
      <Sheet.Content title={props.title} description={props.description}>
        <div className="mx-4 mt-10 mb-8">
          <SweepstakeBadge isWinner={props.isWinner} />
          <p className="text-xl mt-2">{props.title}</p>
          <span className="text-xs text-gray-11">{props.announcementDate}</span>
          <p className="text-sm text-gray-12 mt-6">{props.description}</p>
        </div>
      </Sheet.Content>
    </Sheet.Root>
  )
}

const SweepstakeBadge = ({ isWinner }: { isWinner: boolean }) => (
  <UI.Badge kind={isWinner ? "positive" : "outline"}>
    {isWinner ? "You won!" : "You're in the drawing"}
  </UI.Badge>
)

namespace ExclusiveSweepstakeCard {
  export type Props = {
    id: string
    title: string
    subtitle?: string
    coverImage: string
    isWinner: boolean
    announcementDate: string
    description: string
  }
}
